// API base URL resolver
// - 운영 도메인에서 REACT_APP_API_URL이 localhost로 박혀 있으면 브라우저에서 Network Error가 납니다.
// - 기본은 같은 오리진 프록시(/api)를 타도록 빈 문자열을 반환합니다.

export function getApiBaseUrl() {
  const runtime =
    (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_API_URL) ||
    (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__.REACT_APP_API_URL) ||
    '';

  // localStorage override (임시 테스트용)
  const forced =
    (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
      ? String(window.localStorage.getItem('FORCE_API_URL') || '').trim()
      : '');

  const configured = (forced || String(runtime || '').trim() || String(process.env.REACT_APP_API_URL || '').trim());

  // no window (tests/SSR)
  if (typeof window === 'undefined') return '';

  const host = String(window.location?.hostname || '').toLowerCase();
  const isBrowserLocal = host === 'localhost' || host === '127.0.0.1';

  // 설정 없음 → 같은 오리진(빈 base). CRA setupProxy / nginx가 /api 를 백엔드로 나눈다.
  // 예전 localhost:5001 직접 호출은 통합 백엔드 한 곳만 가정한 것이라,
  // /api/erp_approval 등 ERP 전용 경로는 404(Not Found)가 난다.
  if (!configured) {
    return '';
  }

  // 로컬에서 API_URL을 통합 백엔드(5001)만 지정한 경우에도 동일 — ERP 전용 경로는 프록시 필요
  const cTrim = String(configured).trim();
  if (isBrowserLocal && /^https?:\/\/(localhost|127\.0\.0\.1):5001\/?$/i.test(cTrim)) {
    return '';
  }

  const pointsToLocal = /(^|\/\/)(localhost|127\.0\.0\.1)(:|\/|$)/i.test(configured);

  // if we're NOT on localhost but API_URL points to localhost, ignore it and use same-origin (/api)
  if (!isBrowserLocal && pointsToLocal) return '';

  // ✅ 운영 도메인에서는 cross-origin API_URL을 기본으로 사용하지 않음 (CORS 방지)
  // - 운영 호스트들은 nginx가 /api 를 백엔드로 프록시하므로, 기본은 same-origin(/api)
  // - 필요하면 localStorage FORCE_API_URL 로만 강제
  try {
    const u = new URL(configured);
    const sameOrigin = u.origin === window.location.origin;
    const sameOriginProxyHosts = new Set(['admin.borago.kr', 'mail.borago.kr', 'cs.borago.kr', 'admin.mrt.co.kr']);
    const useSameOriginProxy = sameOriginProxyHosts.has(host);
    if (sameOrigin) return '';
    if (useSameOriginProxy && !forced) return '';
  } catch (e) {
    // configured가 상대경로면 그대로 사용
  }

  return configured;
}


